import { CityState, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomerQuickInfo extends Layout {
    citystate1: CityState;
    labelBridgeIdDescription: Textbox;
    labelCustomerWebsite: Textbox;
    panel1: Panel;
    sourceCustomer: DataSource;
    textboxBridgeCustomer: Textbox;
    textboxEdiCustomerCarrier: Textbox;
    textboxId: Textbox;
    textboxName: Textbox;
    textboxPartnerValue: Textbox;
    textboxSalespersonName: Textbox;
    textboxScac: Textbox;
}
